import React, { useEffect, useState, useCallback } from "react";
import Layout from "containers/LayoutV2";
import GiaoDichTrongNgayApi from "service/BaoCao/GiaoDichTrongNgayApi";
import UserApi from "service/userApi";
import StoreApi from "service/phanQuyenApi";
import { SearchBarDesktop } from "./SearchBarDestop";
import { TableDanhSach } from "./TableDanhSach";
import configsRole from "utils/configsRole";
import { KIEU_GIAO_DICH, LOAI_GIAO_DICH } from "utils/giaoDichTrongNgay";
import ConfigSystemApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigSystemApi";
import { BtnInGiaoDich } from "../../BaoCao/GiaoDichTrongNgay/In/BtnInGiaoDich";

export const GiaoDichTrongNgay = () => {
  const initPhanQuyen = {
    giaodichtrongngay: false,
    giaodichtrongngay_chitietmagiaodich: false,
    giaodichtrongngay_chitietkhachhang: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const [loading, setLoading] = useState(true);

  const initialDataSearch = {
    customerName: "",
    money: null,
    typeMoney: "=",
    fromDate: null,
    toDate: null,
    employee: "",
    transactionType: "",
    loaiGiaoDich: 0,
    pageIndex: 1,
    pageSize: 25,
  };
  const [dataSearch, setDataSearch] = useState(initialDataSearch);
  const [listDanhSach, setListDanhSach] = useState({
    Transactions: [],
    TotalRow: 0,
    TotalValue: 0,
  });
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [dsNhanVien, setDsNhanVien] = useState([]);
  const [finalDsKieuGiaoDich, setFinalDsKieuGiaoDich] =
    useState(KIEU_GIAO_DICH);

  const handleGetData = useCallback((searchParams) => {
    setIsLoadingList(true);
    const params = {
      ...searchParams,
      fromDate: searchParams.fromDate,
      toDate: searchParams.toDate,
      money: searchParams.money ? parseFloat(searchParams.money) : null,
      loaiGiaoDich: searchParams.loaiGiaoDich
        ? parseInt(searchParams.loaiGiaoDich)
        : 0,
    };
    GiaoDichTrongNgayApi.getBaoCao(params)
      .then((res) => {
        if (res.status === 200) {
          setListDanhSach({
            Transactions: res.data.Transactions || [],
            TotalRow: res.data.TotalRow || 0,
            TotalValue: res.data.TotalValue || 0,
          });
        } else {
          setListDanhSach({ Transactions: [], TotalRow: 0, TotalValue: 0 });
        }
      })
      .catch(() =>
        setListDanhSach({ Transactions: [], TotalRow: 0, TotalValue: 0 })
      )
      .finally(() => setIsLoadingList(false));
  }, []);
  const LoadInitialData = () => {
    setLoading(true);
    StoreApi.getAllQuyen()
      .then((resQuyen) => {
        if (resQuyen.status === 200) {
          const getRole = (code) =>
            resQuyen.data.some(
              (e) => e.ModuleCode?.toUpperCase() === code.toUpperCase()
            );
          const newPhanQuyen = {
            giaodichtrongngay: getRole(configsRole.sRole.giaodichtrongngay),
            giaodichtrongngay_chitietmagiaodich: getRole(
              configsRole.sRole.giaodichtrongngay_chitietmagiaodich
            ),
            giaodichtrongngay_chitietkhachhang: getRole(
              configsRole.sRole.giaodichtrongngay_chitietkhachhang
            ),
          };
          setPhanQuyen(newPhanQuyen);
          return newPhanQuyen.giaodichtrongngay;
        }
        return false;
      })
      .then((hasAccess) => {
        if (hasAccess) {
          handleGetData(dataSearch);
          UserApi.combo2()
            .then((nhanVienRes) => {
              if (nhanVienRes.status === 200) setDsNhanVien(nhanVienRes.data);
            })
            .catch(console.error);
          ConfigSystemApi.getCauHinhHeThong()
            .then((configRes) => {
              if (
                configRes.status === 200 &&
                configRes.data &&
                configRes.data.BanHangTraGop === 1
              ) {
                const bhtgOption = { value: "BHTG", label: "Bán hàng trả góp" };
                const newList = [...KIEU_GIAO_DICH];
                newList.splice(3, 0, bhtgOption);
                setFinalDsKieuGiaoDich(newList);
              }
            })
            .catch(console.error);
        }
      })
      .catch((e) => {
        console.error("Lỗi tải dữ liệu ban đầu:", e);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    document.title = "Giao dịch trong ngày | Phần mềm Morman";
    LoadInitialData();
  }, []);

  // if (loading) return null;

  return (
    <Layout>
      {phanQuyen.giaodichtrongngay ? (
        <div id="form-repeater" className="p-1">
          <div className="breadcrumb-new" style={{ marginBottom: "5px" }}>
            <div className="row header justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <img
                  src="/app-assets/images/icon-thong-ke.png"
                  alt="Mẫu hợp đồng"
                />
                <h1
                  className="text-info-home"
                  style={{ marginLeft: "10px", marginBottom: 0 }}
                >
                  Giao Dịch Trong Ngày
                </h1>
              </div>
              <div>
                <BtnInGiaoDich
                  dataSearch={dataSearch}
                  listDanhSach={listDanhSach}
                />
              </div>
            </div>
          </div>
          <div>
            <SearchBarDesktop
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              onSearch={handleGetData}
              dsNhanVien={dsNhanVien}
              dsKieuGiaoDich={finalDsKieuGiaoDich}
              dsLoaiGiaoDich={LOAI_GIAO_DICH}
            />
            <TableDanhSach
              phanQuyen={phanQuyen}
              listDanhSach={listDanhSach}
              isLoading={isLoadingList}
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              onSearch={handleGetData}
            />
          </div>
        </div>
      ) : (
        <div className="p-1 text-center text-danger">
          Bạn không có quyền truy cập chức năng này.
        </div>
      )}
    </Layout>
  );
};
